import { useCallback } from 'react';
import { formatTimezoneAndDateTime } from 'services/UtilityService';
import useMobxStores from './useMobxStores';

export default function useUserTimezone(): {
  userTimezone: string;
  formatDatetime: (isoString: string, format?: string) => string;
} {
  const { userStore } = useMobxStores();
  const profileTz = userStore?.user?.default_timezone;
  const userTimezone =
    profileTz || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

  const formatDatetime = useCallback(
    (isoString: string, format?: string) =>
      formatTimezoneAndDateTime(isoString, userTimezone, format),
    [userTimezone],
  );

  return { userTimezone, formatDatetime };
}
